import { render } from "./SamplePoint.vue?vue&type=template&id=6cff7651&scoped=true"
import script from "./SamplePoint.vue?vue&type=script&lang=js"
export * from "./SamplePoint.vue?vue&type=script&lang=js"

import "./SamplePoint.vue?vue&type=style&index=0&id=6cff7651&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cff7651"]])

export default __exports__